import {
  createBackendRouteInvoker,
  resolveTransportForRoute,
} from '../../../../shared/backend/invoke';
import { invokeApiStreamRoute } from './transports/apiStream';
import {
  invokeCallableRoute,
  invokeCallableStreamRoute,
} from './transports/callable';
import type { HttpsCallableStreamOptions } from 'firebase/functions';
import { invokeHttpRoute } from './transports/http';
import { routeTable } from './routes';

export { resolveTransportForRoute };

export const invokeBackendRoute = createBackendRouteInvoker<
  typeof routeTable,
  HttpsCallableStreamOptions
>({
  routeTable,
  invokeCallableRoute,
  invokeHttpRoute,
  invokeCallableStreamRoute,
  invokeApiStreamRoute,
});
